export const CONFIG = {
  "hashKey": "dw3o292@93",
  "apiUrl": "https://api.shypes.com",
  "mediaUrl": "https://media.shypes.com",
  "socketServerUrl": "https://socket.shypes.com",
  "enableSocket": true,
  "socketMode": "websocket",
  "baseDomain": "circleplug.com",
  "swwipeMode": "live",
  "statesApiKey": "20586d2837a7f0424ce7b79ebc5ef40fd90e24426e5343f2c6f0d3075036d8d3"
};
